import { useQuery } from '@tanstack/react-query';
import { rbacQueries } from '../api/rbac-queries';
import type { RouteFilters, GrantFilters, FeatureFilters } from './list-params';
export const useRbacSubjects = () => useQuery(rbacQueries.subjects());
export const useRbacRoutes = (filters: RouteFilters) =>
  useQuery(rbacQueries.routes(filters));
export const useRbacRoute = (id: string) => useQuery(rbacQueries.route(id));
export const useRbacMatrix = (filters: RouteFilters) =>
  useQuery(rbacQueries.matrix(filters));
export const useRbacGrants = (filters: GrantFilters) =>
  useQuery(rbacQueries.grants(filters));
export const useRbacFieldRules = (id: string) => useQuery(rbacQueries.fieldRules(id));
export const useRbacAudit = (beforeId?: number) => useQuery(rbacQueries.audit(beforeId));
export const useRbacFeatures = (filters: FeatureFilters) =>
  useQuery(rbacQueries.features(filters));
export const useRbacFeature = (id: number) => useQuery(rbacQueries.feature(id));
